import React, { useMemo } from "react";
import { useSelector } from "react-redux";
import {
  PieChart,
  Pie,
  Cell,
  Tooltip,
  ResponsiveContainer,
} from "recharts";

export const COLORS = [
  "#E4D354", // rgb(228, 211, 84)
  "#22B2D4", // rgb(34, 178, 212)
  "#28A745",
  "#566374",
  "#1976D2",
  "#DC3545",
  "#0A83A1",
  "#045266"
];

const PieChartMaint = ({ data, mode }) => {
    const logInUser = useSelector((state) => state.logInUsers);
  const currency = logInUser?.attributes?.currencyLabel || "AED";

  const chartData = useMemo(() => {
    const safeData = data?.filter(
      d => typeof d.SaleNetAmount === "number" && !isNaN(d.SaleNetAmount) && d.SaleNetAmount >= 0
    ) || [];

    if (safeData.length === 0) {
      return [
        { name: "No Data", value: 0.00001, count: 0, color: "#aec9eb" }
      ];
    }

    const saleAmounts = safeData.map(d => d.SaleNetAmount);
    const minLog = Math.log10(Math.min(...saleAmounts) + 1);
    const maxLog = Math.log10(Math.max(...saleAmounts) + 1);

    const range = maxLog - minLog || 1;

    return safeData.map((item, index) => ({
      name: item.plateNumber,
      value: ((Math.log10(item.SaleNetAmount + 1) - minLog) / range) * 100,
      count: item.Count,
      color: COLORS[index % COLORS.length],
    }));
  }, [data]);

  const CustomTooltip = ({ active, payload }) => {
    if (active && payload?.length) {
      const d = payload[0].payload;
      if (d.name === "No Data") return null;

      return (
        <div
          style={{
            background: "#fff",
            color: "black",
            border: "1px solid #ccc",
            padding: 8,
            borderRadius: 4,
          }}
        >
          <b>Vehicle License Plate:</b> {d.name}
          <br />
          <b>{mode === "costPerKm" ? "Cost per KM" : "Cost per Day"}:</b>{" "}
          {Number(d.value).toLocaleString(undefined, {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          })}
          {currency}
          <br />
          <b>Maint Count:</b> {d.count}
        </div>
      );
    }
    return null;
  };

  return (
    <div style={{ width: "100%", height: 300,padding:"1rem" }}>
      <ResponsiveContainer width="100%" height="100%">
        <PieChart>
          <Pie
            data={chartData}
            dataKey="value"
            nameKey="name"
            innerRadius={"35%"}
            outerRadius={"70%"}
            label={({ name, percent }) =>
              name === "No Data" ? "" : `${name}: ${(percent * 100).toFixed(1)}%`
            }
          >
            {chartData.map((entry, index) => (
              <Cell key={`cell-${index}`} fill={entry.color} />
            ))}
          </Pie>
          <Tooltip content={<CustomTooltip />} />
        </PieChart>
      </ResponsiveContainer>
    </div>
  );
};

export default PieChartMaint;
